import {ItemType} from "../../API";
import type {ItemModelType, WorkspaceModelType} from "@stores/WorkspaceStore";

export function getDefaultCreateItemParentId(workspace: WorkspaceModelType): string {
    const targetLibrary = workspace.selectedLibrary;
    if (!targetLibrary) {
        throw new Error(`Cannot create item in workspace ${workspace.id}: no active library found`);
    }

    return targetLibrary.id;
}

export function resolveCreateItemParentId(
    workspace: WorkspaceModelType,
    parentId?: string | null
): string {
    return parentId ?? getDefaultCreateItemParentId(workspace);
}

export function assertCanContainChild(parent: ItemModelType, childType: ItemType): void {
    if (childType === ItemType.LIBRARY) {
        return;
    }

    if (!parent.isLibrary && !parent.isCluster) {
        throw new Error(`Cannot create ${childType} under non-container item ${parent.id}`);
    }
}

export function getCreateItemParent(
    workspace: WorkspaceModelType,
    parentId: string,
    childType: ItemType
): ItemModelType {
    const parent = workspace.items.get(parentId);
    if (!parent) {
        throw new Error(`Cannot create ${childType}: parent item ${parentId} not found`);
    }

    assertCanContainChild(parent, childType);
    return parent;
}
